import { render, staticRenderFns } from "./digital-management.vue?vue&type=template&id=41dca5f7"
import script from "./digital-management.vue?vue&type=script&lang=js"
export * from "./digital-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports